import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import { NIKAO_BRAND } from "./constants/nikaoBrand";

const theme = createTheme({
  palette: {
    primary: {
      main: NIKAO_BRAND.ocean,
      dark: NIKAO_BRAND.aubergine,
      light: NIKAO_BRAND.teal,
      contrastText: NIKAO_BRAND.white,
    },
    secondary: {
      main: NIKAO_BRAND.teal,
      dark: "#008F6B",
      light: NIKAO_BRAND.lime,
      contrastText: NIKAO_BRAND.aubergine,
    },
    background: {
      default: "#F4F5F7",
      paper: NIKAO_BRAND.white,
    },
    text: {
      primary: NIKAO_BRAND.aubergine,
      secondary: "rgba(22, 14, 43, 0.68)",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: NIKAO_BRAND.aubergine,
          color: NIKAO_BRAND.white,
          boxShadow: "none",
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        containedPrimary: {
          backgroundColor: NIKAO_BRAND.ocean,
          "&:hover": {
            backgroundColor: "#005A8C",
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
